import './Dropdown.css';
import styles from './AppFooter.module.less';
import Dropdown, {
	DropdownContent,
	DropdownTrigger,
} from 'react-simple-dropdown';
import arrowDown from 'assets/img/v-arrow-down.svg';

function DropDown() {
	return (
		<Dropdown>
			<DropdownTrigger className={styles.footerSubdomainLinks}>
				<div className={styles.footerDisplay768Border}>
					<div className={styles.footerTextPadding}>
						Virtuix{' '}
						<img
							className={styles.footerVArrowDown}
							src={arrowDown}
							alt="Click Arrow Down"
						/>
					</div>
				</div>
			</DropdownTrigger>
			<DropdownContent>
				<ul className={styles.footerDisplay768}>
					<li>
						<div className={styles.footerPageLinks}>
							<a href="https://virtuix.com" className={styles.footerLinkGray}>
								Home
							</a>
						</div>
					</li>
					<li>
						<div className={styles.footerPageLinks}>
							<a
								href="https://virtuix.com/who-we-are"
								className={styles.footerLinkGray}
							>
								Who We Are
							</a>
						</div>
					</li>
					<li>
						<div className={styles.footerPageLinks}>
							<a
								href="https://virtuix.com/careers"
								className={styles.footerLinkGray}
							>
								Careers
							</a>
						</div>
					</li>
					<li>
						<div className={styles.footerPageLinks}>
							<a
								href="https://virtuix.com/legal"
								className={styles.footerLinkGray}
							>
								Legal
							</a>
						</div>
					</li>
					<li>
						<div className={styles.footerPageLinks}>
							<a
								href="https://virtuix.com/investors"
								className={styles.footerLinkGray}
							>
								Investors
							</a>
						</div>
					</li>
					<li>
						<div className={styles.footerPageLinks}>
							<a
								href="https://virtuix.com/press"
								className={styles.footerLinkGray}
							>
								Press
							</a>
						</div>
					</li>
				</ul>
			</DropdownContent>
		</Dropdown>
	);
}

export default DropDown;
